/* istanbul ignore file */
import React, { ReactElement } from 'react';
import Tab from 'components/Tab';
import { TTab, TTabKey } from 'components/Tab/Tab.types';
import { getUrlParams } from 'utils/urlParams';
import { sendRaffleEvent } from 'pages/Raffle/helpers/raffleHelper/raffleHelper';
import TabSuspense from '../../../MobileTopup/components/TabSuspense';
import MainCarousel from './components/MainCarousel';
import RaffleLandingModal from './components/RaffleLandingModal';
import { RaffleTabsProvider } from '../../../../contexts/RaffleTabsProvider/RaffleTabsProvider';
import { isNewFeatureForABTesting } from '../../../../utils/abTestCookieHelper/abTestCookieHelper';
import { useUserFlag } from '../../../../contexts/UserFlagProvider';

const Raffles = React.lazy(() => import('../Raffles'));
const RaffleResults = React.lazy(
  () => import('../RaffleResults/RaffleResults')
);
const Tickets = React.lazy(() => import('../Tickets/Tickets'));
const Winnings = React.lazy(() => import('../Winnings'));

const tabs: TTab[] = [
  {
    component: <TabSuspense element={Raffles} />,
    header: 'Çekilişler',
    key: 'raffles',
  },
  {
    component: <TabSuspense element={Tickets} />,
    header: 'Biletlerim',
    key: 'raffle-tickets',
  },
  {
    component: <TabSuspense element={Winnings} />,
    header: 'Kazandırdıklarımız',
    key: 'raffle-winnings',
  },
  {
    component: <TabSuspense element={RaffleResults} />,
    header: 'Çekiliş Sonuçları',
    key: 'raffle-results',
  },
];

function RaffleTabs(): ReactElement {
  function onTabChange(tabKey: TTabKey) {
    sendRaffleEvent({ action: 'tabclick', tab: `${tabKey}` });
  }
  const { userFlags } = useUserFlag();
  const isNew = isNewFeatureForABTesting(
    userFlags,
    'RAFFLE_LANDING_MODAL_COOKIE'
  );
  const currentTab = getUrlParams().get('tab');

  return (
    <RaffleTabsProvider>
      <Tab
        gutter
        tabs={tabs}
        beforeContent={currentTab !== 'raffles' && <MainCarousel />}
        onTabChange={onTabChange}
        selectedTab={currentTab || window.location.pathname.split('/')[1]}
      />
      {isNew && <RaffleLandingModal />}
    </RaffleTabsProvider>
  );
}

export default RaffleTabs;
